import { ProductType } from '@apps/api-interfaces';

export const setTheme = (
  type: ProductType = 'prad',
  rootElement = document.body
) => {
  const d = rootElement || document.body;
  d.setAttribute('data-sc-theme', type);
};

export const trimUrl = (_url: string): string => {
  let url = _url;
  if (url.indexOf('?') > -1) {
    url = url.substring(0, url.indexOf('?'));
  }
  if (url.indexOf('#') > -1) {
    url = url.substring(0, url.indexOf('#'));
  }
  return url;
};
